// removed by extract-text-webpack-plugin
module.exports = {"popover":"popover___1I8x_","noticeButton":"noticeButton___1mzmC","icon":"icon___r2u09","tabs":"tabs___27Mjh"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NoticeIcon/index.less
// module id = 443
// module chunks = 0